export default "__VITE_ASSET__oP8ssZp8__"